/**
 * The Canvas logo: a "C" cut out of a squircle. Drawn in the current text
 * colour, so it follows the theme and whatever it sits next to. Same shape as
 * `public/favicon.svg`.
 */
export const CanvasLogo = ({ size = "1.15em" }: { size?: string }) => (
  <svg
    className="CanvasLogo"
    viewBox="0 0 512 512"
    width={size}
    height={size}
    aria-hidden="true"
    focusable="false"
    style={{ flex: "0 0 auto" }}
  >
    <mask id="canvas-logo-c">
      <rect width="512" height="512" fill="#fff" />
      <path
        d="M338.9 172.8A112 112 0 1 0 338.9 339.2"
        fill="none"
        stroke="#000"
        strokeWidth="60"
        strokeLinecap="round"
      />
    </mask>
    <path
      d="M256 0C488.7 0 512 23.3 512 256C512 488.7 488.7 512 256 512C23.3 512 0 488.7 0 256C0 23.3 23.3 0 256 0Z"
      fill="currentColor"
      mask="url(#canvas-logo-c)"
    />
  </svg>
);
